import { render, staticRenderFns } from "./OrderViewProxy.vue?vue&type=template&id=438d972a&"
import script from "./OrderViewProxy.vue?vue&type=script&lang=js&"
export * from "./OrderViewProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports